import { S3Client, PutObjectCommand, GetObjectCommand, DeleteObjectCommand } from '@aws-sdk/client-s3';
import { fetchAuthSession } from 'aws-amplify/auth';

const REGION = 'eu-west-1';
const BUCKET = 'reiskosten-thuiswerk-zwijsen';

async function getClient() {
  const session = await fetchAuthSession();
  return new S3Client({ region: REGION, credentials: session.credentials });
}

export async function uploadReceipt(userId, year, month, id, file) {
  const client = await getClient();
  const ext = file.name.split('.').pop().toLowerCase();
  const key = `declaraties/${userId}/${year}-${String(month + 1).padStart(2, '0')}/${id}.${ext}`;
  const bytes = new Uint8Array(await file.arrayBuffer());
  await client.send(new PutObjectCommand({ Bucket: BUCKET, Key: key, Body: bytes, ContentType: file.type }));
  return key;
}

export async function downloadReceipt(key) {
  const client = await getClient();
  const response = await client.send(new GetObjectCommand({ Bucket: BUCKET, Key: key }));
  return await new Response(response.Body).blob();
}

export async function deleteReceipt(key) {
  const client = await getClient();
  await client.send(new DeleteObjectCommand({ Bucket: BUCKET, Key: key }));
}

export async function uploadOvBonnetje(userId, year, month, dateString, file) {
  const client = await getClient();
  const ext = file.name.split('.').pop().toLowerCase();
  const key = `declaraties/${userId}/${year}-${String(month + 1).padStart(2, '0')}/ov_${dateString}.${ext}`;
  const bytes = new Uint8Array(await file.arrayBuffer());
  await client.send(new PutObjectCommand({ Bucket: BUCKET, Key: key, Body: bytes, ContentType: file.type }));
  return key;
}
